document.addEventListener('DOMContentLoaded', () => {
    const resultItems = document.querySelectorAll('.portfolio__heading');

    // Options for the IntersectionObserver
    const options = {
        threshold: 0.5 // Trigger when 50% of the element is in the viewport
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counterElements = entry.target.querySelectorAll('.result__number');

                counterElements.forEach(counterElement => {
                    const counterNumber = +counterElement.getAttribute('data-counter-number');
                    const speed = 250;
                    let currentNumber = 0;

                    const updateCount = () => {
                        const increment = counterNumber / speed;
                        currentNumber += increment;

                        if (currentNumber < counterNumber) {
                            counterElement.innerText = '+' + Math.ceil(currentNumber) + '%';
                            setTimeout(updateCount, 1);
                        } else {
                            counterElement.innerText = '+' + counterNumber + '%';
                        }
                    };

                    updateCount();
                });
            }
        });
    }, options);

    // Observe each result item
    resultItems.forEach(resultItem => {
        observer.observe(resultItem);
    });
});


document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollToPlugin);
    const btn = document.querySelector('.box')
    btn.addEventListener("click", () => {
      gsap.to(window, { duration: 1.5, scrollTo: { y: "#case-detail-tab", offsetY: 120 } });
    });
  })
